import styled from 'styled-components';


export const SuccessMsgWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: 30px 0;
        line-height: 1.5;
        align-items: center;
        justify-content: center;
        text-align:center;
        flex-direction: column;
        height: 60rem;
    `,
)

export const SuccessMsgText =  styled.p`
    font-size: 24px;
    color: green;
    line-height: 1.5;
    font-weight: 600;
    padding-bottom: 10px;
`;

export const CheckCircleWrap = styled.div`
    width: 60px;
    height:60px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: green;
    margin-bottom: 20px;
`;

export const InfoText = styled.p`
    font-size: 16px;
    color: #333;
    line-height: 1.3;
    padding-top: 5px;
`;